/*doc
---
title: JS Navigation
name: zz-js-navigation
category: base
---

Javascript module to toggle the mobile navigation state

```javascript
Navigation.create();

```

*/

var {
  each,
  create,
  on,
  off,
  addClass,
  removeClass,
  preventDefault,
  stopPropagation
} = require('../utils');

var { maxWidth } = require('./Breakpoints');

const OPEN_CLASS = 'navigation--open';
const NAVIGATION_SELECTOR = '.navigation--mobile__slider';
const TRIGGER_SELECTOR = '.js-navigation-trigger';
const TRIGGER_ACTIVE = 'navigation-trigger--active';

class Navigation {
  constructor() {
    this.navigationLayer = document.querySelectorAll(NAVIGATION_SELECTOR);
    this.triggers = document.querySelectorAll(TRIGGER_SELECTOR);

    this.isOpen = false;
    this.attachHandler();
  }

  attachHandler() {
    each(this.triggers, (trigger) => {
      on(trigger, 'click', (e) => {
        preventDefault(e);
        // stop propagation to disable closing on body.click
        stopPropagation(e);
        this.toggle();
      }, false);
    });

    on(window, 'resize', () => {
      if (this.isOpen && maxWidth('sm')) {
        this.close();
      }
    });
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (!this.isOpen) {
      this.isOpen = true;

      addClass(document.body, OPEN_CLASS);
      addClass(this.triggers, TRIGGER_ACTIVE);

      this.activateOutsideClick();
    }
  }

  close() {
    if (this.isOpen) {
      this.isOpen = false;
      removeClass(document.body, OPEN_CLASS);
      removeClass(this.triggers, TRIGGER_ACTIVE);

      this.deactivateOutsideClick();
    }
  }

  activateOutsideClick() {
    this.boundClose = this.boundClose || this.close.bind(this);
    on(this.navigationLayer, 'click', stopPropagation);
    on(this.navigationLayer, 'touchstart', stopPropagation);
    on(document.body, 'click', this.boundClose);
    on(document.body, 'touchstart', this.boundClose);
  }

  deactivateOutsideClick() {
    off(this.navigationLayer, 'click', stopPropagation);
    off(this.navigationLayer, 'touchstart', stopPropagation);
    off(document.body, 'click', this.boundClose);
    off(document.body, 'touchstart', this.boundClose);
  }
}

export default create(Navigation);



// WEBPACK FOOTER //
// ./src/scripts/components/Navigation.js